import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/surveys',
        component: () => import('@/pages/surveys/SurveysIndex.vue'),
        props: true,
        children: [
            {
                name: 'surveys-index',
                path: '',
                component: () => import('@/components/quizzes/QuizzesView.vue'),
                meta: {
                    title: 'Surveys',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view all', subject: 'quizzes' },
                },
                props: true,
            },

            {
                name: 'surveys-index-archive',
                path: '/surveys/archive',
                component: () => import('@/components/quizzes/QuizzesView.vue'),
                meta: {
                    title: 'Archived Surveys',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => gateKeeper.userHasPermission('archive a survey'),
                },
                props: true,
            },
        ],
    },

    {
        path: '/surveys/import',
        name: 'survey-import',
        component: () => import('@/pages/quizzes/ImportQuiz.vue'),
        meta: {
            title: 'Create Survey',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'create', subject: 'quiz' },
        },
        props: true,
    },

    {
        path: '/surveys/:quizId',
        name: 'survey-view',
        component: () => import('@/pages/quizzes/QuizView.vue'),
        meta: {
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view', subject: 'quiz' },
        },
        props: true,
    },
    {
        path: '/survey/:id/automated/:assignmentId/:attemptId?',
        component: () => import('@/pages/courses/quizzes/Quiz.vue'),
        props: true,
        children: [
            {
                name: 'automated-survey-attempt',
                path: '',
                component: () => import('@/components/quiz-attempt/QuizAttempt.vue'),
                meta: {
                    title: 'Evaluation',
                    middleWare: [GateKeeperMiddleware],
                    ability: { action: 'take', subject: 'quiz' },
                },
            },
        ],
    },
];
